// extracted by mini-css-extract-plugin
export default {"searchListWrapper":"searchListStyles_searchListWrapper__XbwwW","searchListInnerWrapper":"searchListStyles_searchListInnerWrapper__SK4wN"};